//!nordy - 허용된 사이드바 탭 ID 목록
// 이 목록에 없는 탭은 registerSidebarTab에서 차단됨
export const ALLOWED_SIDEBAR_TAB_IDS: ReadonlySet<string> = new Set([
  'job-history', // default
  'assets', // default
  'node-library', // default
  'model-library', // default
  // 'workflows', // default
  'easyuse_nodes_map' // default
])
